/**
 * form Form Data Redux reducer
 */

import {
  CREATE_FORM_ELEMENTS,
  ADD_MARKETING_ELEMENT,
  UPDATE_FORM,
  SHOW_FORM,
  SHOW_ERROR,
  SHOW_SUCCESS,
  SHOW_LOADER,
  SET_SHOW_USER_ERRORS,
  MARKETING_CONSENT_POST,
  SET_REQUIRE_ADDRESS,
  INVALID,
  VALID,
  SET_GOOGLE_ADDRESS_IS_OPEN,
  UPDATE_FORM_ERRORS
} from './constants'

const initialState = {
  initialised: false,
  showUserErrors: false,
  formContainsErrors: false,
  marketingConsentElements: [],
  hasMarketingConsentPost: false,
  googleAddressIsNeeded: false,
  googleAddressIsOpen: false,
  googleAddressFields: [],
  googleAddressFieldsParamKeys: [],
  showForm: true,
  showError: false,
  showSucess: false,
  showLoader: false,
  rows: [],
  formData: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_FORM_ELEMENTS:
      return { ...state, formData: action.payload, initialised: true }

    case UPDATE_FORM:
      return { ...state, formData: action.payload }

    case UPDATE_FORM_ERRORS:
      return { ...state, formContainsErrors: action.payload }

    case SHOW_FORM:
      return { ...state, showForm: true, showError: false }

    case SET_GOOGLE_ADDRESS_IS_OPEN:
      return { ...state, googleAddressIsOpen: action.payload }

    case SET_REQUIRE_ADDRESS:
      // watch out, we need to make sure the google address fields are correct
      let i
      if (action.payload) {
        for (i = 0; i < state.googleAddressFields.length; i++) {
          const key = state.googleAddressFields[i]
          if (state.formData[key].value === '') {
            state.formData[key].valid = INVALID
          }
        }
      } else {
        if (state.googleAddressIsOpen) {
          for (i = 0; i < state.googleAddressFields.length; i++) {
            const key = state.googleAddressFields[i]
            if (state.formData[key].value === '') {
              state.formData[key].valid = VALID
            }
          }
        }
      }
      return { ...state, googleAddressIsNeeded: action.payload }

    case SHOW_ERROR:
      return { ...state, showError: action.payload, showSuccess: false }

    case SET_SHOW_USER_ERRORS:
      return { ...state, showUserErrors: action.payload }

    case ADD_MARKETING_ELEMENT:
      const a = state.marketingConsentElements
      const hasPost =
        action.payload.name === MARKETING_CONSENT_POST
          ? true
          : state.hasMarketingConsentPost
      a.push(action.payload)

      return {
        ...state,
        marketingConsentElements: a,
        hasMarketingConsentPost: hasPost
      }

    case SHOW_SUCCESS:
      return {
        ...state,
        showSuccess: action.payload,
        showError: false,
        showForm: false
      }

    case SHOW_LOADER:
      return { ...state, showLoader: action.payload }

    default:
      return state
  }
}
